module.exports = __webpack_public_path__ + "static/media/shareimage.997cc3e9.png";